import {
  Context,
  UseUserShippingFactoryParams,
  useUserShippingFactory
} from '@vue-storefront/core';
import type {
  UserShippingAddress as Address,
  UserShippingAddressItem as AddressItem
} from '@bee-hole/api';
import { useApiError } from '../useApiError';

const params1: UseUserShippingFactoryParams<Address, AddressItem> = {
  provide: () => ({
    useApiError: useApiError()
  }),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  addAddress: async (context: Context, { address }) => {
    // console.log('address', address);
    const res = await context.$xbuy.api.customUpdateaddress(address);
    if (res && res.code && res.code > 0) {
      context.useApiError.set(res);
      throw new Error(res.message);
    }
    return res.data;
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  deleteAddress: async (context: Context, params) => {
    // console.error(context,params.address['address_id']);
    await context.$xbuy.api.customDeleteAddress({ address_id: params.address.addressId });
    const shipping: Address = {
      list: [],
      total: 0,
      page: 0,
      limit: 0
    };
    // const address = await params1.load(context, { shipping });
    return shipping;
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  updateAddress: async (context: Context, { address }) => {
    // const newAddress = {
    //   address_id: params.address.addressId,
    //   first_name: params.address.firstName,
    //   last_name: params.address.lastName,
    //   street: params.address.streetName,
    //   apartment: params.address.apartment,
    //   city: params.address.city,
    //   state: params.address.state,
    //   zip_code: params.address.zipCode,
    //   country: params.address.country,
    //   phone: params.address.phoneNumber,
    //   sort: params.address.sort,
    //   is_default: params.address.isDefault
    // };
    // console.error('更新地址：', newAddress);
    // return false;
    const res = await context.$xbuy.api.customUpdateaddress(address);
    if (res && res.code && res.code > 0) {
      context.useApiError.set(res);
      throw new Error(res.message);
    }
    return res.data;
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  load: async (context: Context, parmas) => {
    const res = await context.$xbuy.api.customShipping({page: 1, limit: 150 });
    if (res && res.code && res.code > 0) {
      context.useApiError.set(res);
      throw new Error(res.message);
    }
    return res.data;
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setDefaultAddress: async (context: Context, params) => {
    // console.log('Mocked: useUserShipping.setDefaultAddress');
    const res = await context.$xbuy.api.customSetDefault(params);
    return res.data;
  }
};

export const useUserShipping = useUserShippingFactory<Address, AddressItem>(params1);
